<template>

  <div class="parent-view-container">
    <notifications group="app-notification" />
    <template v-if="this.$store.getters.token">
        <HomeView />
      </template>
    <template v-else>
        <Login />
      </template>
  </div>

</template>

<script>

  // import Navigation from '@/components/Navigation.vue'
  import Login from '@/components/Login.vue'
  import HomeView from '@/views/HomeView.vue'

  export default {
    name: 'ParentView',
    components: {
      HomeView,
      Login
    }
  }

</script>

<style>

  .parent-view-container {
    height: 100%;
  }

</style>
